var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CBadge',_vm._g({attrs:{"rounded":_vm.rounded,"bg-class":"tw-bg-teal-500","text-class":"tw-text-white"}},_vm.$listeners),[_vm._v("\n  Leasing\n")])}
var staticRenderFns = []

export { render, staticRenderFns }